import { globalStyles } from "@client/shared/constants";

const style = {
  pageTitleWrapper: {
    borderRadius: 2,
  },
  tableContainer: {
    // "border-radius": "10px",
    "max-height": "300px !important",
  },
};

export default style;
